import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, vModelSelect as _vModelSelect, Transition as _Transition, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f14b11e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "kt_modal_create_event",
  ref: "createEventModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog mw-1200px" }
const _hoisted_3 = ["validation-schema"]
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fs-3 el-icon el-dialog__close" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ])
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body p-4 scroll-y bg-opacity-50 bg-light min-h-550px" }
const _hoisted_9 = {
  class: "stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid",
  id: "kt_modal_create_app_stepper",
  ref: "createAppRef"
}
const _hoisted_10 = { class: "d-flex justify-content-center justify-content-xl-start flex-row-auto py-5 border w-100 w-xl-250px bg-white rounded-3 min-h-550px" }
const _hoisted_11 = { class: "stepper-nav ps-lg-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "1")
], -1))
const _hoisted_14 = { class: "stepper-label" }
const _hoisted_15 = { class: "stepper-title" }
const _hoisted_16 = { class: "stepper-desc" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "2")
], -1))
const _hoisted_19 = { class: "stepper-label" }
const _hoisted_20 = { class: "stepper-title" }
const _hoisted_21 = { class: "stepper-desc" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-icon w-40px h-40px" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper-number" }, "3")
], -1))
const _hoisted_24 = { class: "stepper-label" }
const _hoisted_25 = { class: "stepper-title" }
const _hoisted_26 = { class: "stepper-desc" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepper-line w-40px" }, null, -1))
const _hoisted_28 = { class: "stepper-icon w-40px h-40px" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "stepper-check fas fa-check" }, null, -1))
const _hoisted_30 = { class: "stepper-number" }
const _hoisted_31 = { class: "stepper-label" }
const _hoisted_32 = { class: "stepper-title" }
const _hoisted_33 = { class: "stepper-desc" }
const _hoisted_34 = { class: "flex-row-fluid px-lg-6 bg-white py-5 ms-5 mh-700px scroll-y border rounded-3" }
const _hoisted_35 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_36 = { class: "w-100" }
const _hoisted_37 = { class: "fv-row mb-5" }
const _hoisted_38 = { class: "d-flex align-items-center mb-2" }
const _hoisted_39 = { class: "required" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify your unique event name"
}, null, -1))
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-lg-6 col-md-6 mb-5" }
const _hoisted_43 = { class: "d-flex align-items-center mb-2" }
const _hoisted_44 = { class: "required" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify your unique event type"
}, null, -1))
const _hoisted_46 = { class: "col-lg-6 col-md-6 mb-5" }
const _hoisted_47 = { class: "d-flex align-items-center mb-2" }
const _hoisted_48 = { class: "required" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify your unique event sub type"
}, null, -1))
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-lg-6 col-md-6 mb-10" }
const _hoisted_52 = { class: "required mb-2" }
const _hoisted_53 = { class: "d-flex flex-column fv-row w-100" }
const _hoisted_54 = { class: "col-lg-6 col-md-6 mb-10" }
const _hoisted_55 = { class: "mb-2" }
const _hoisted_56 = { class: "d-flex flex-column fv-row w-100" }
const _hoisted_57 = { "data-kt-stepper-element": "content" }
const _hoisted_58 = { class: "w-100" }
const _hoisted_59 = { class: "fv-row" }
const _hoisted_60 = { class: "fv-row mb-5" }
const _hoisted_61 = { class: "d-flex align-items-center mb-2" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify your unique communication mode"
}, null, -1))
const _hoisted_63 = { class: "fv-row" }
const _hoisted_64 = { class: "d-flex align-items-center mb-2" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = {
  key: 1,
  class: "required"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify your unique template"
}, null, -1))
const _hoisted_68 = { id: "kt_inbox_compose_form" }
const _hoisted_69 = { class: "d-block" }
const _hoisted_70 = { class: "d-flex align-items-center mb-4" }
const _hoisted_71 = {
  key: 1,
  class: "d-flex flex-column fv-row w-100"
}
const _hoisted_72 = {
  key: 2,
  class: "d-flex flex-column fv-row w-100"
}
const _hoisted_73 = {
  key: 0,
  class: "d-flex align-items-center mb-4"
}
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark w-75px" }, "CC:", -1))
const _hoisted_75 = { class: "d-flex flex-column fv-row w-100" }
const _hoisted_76 = {
  key: 1,
  class: "d-flex align-items-center mb-4"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark w-75px" }, "BCC:", -1))
const _hoisted_78 = { class: "d-flex flex-column fv-row w-100" }
const _hoisted_79 = {
  key: 2,
  class: "d-flex align-items-center border-bottom min-h-50px"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-dark w-75px" }, "Subject:", -1))
const _hoisted_81 = { class: "d-flex flex-column fv-row w-100" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap gap-2 py-5 ps-8 pe-5 border-top" }, null, -1))
const _hoisted_83 = {
  key: 0,
  class: "row"
}
const _hoisted_84 = { class: "col-lg-6 fv-row mb-4" }
const _hoisted_85 = { class: "required mb-2" }
const _hoisted_86 = { class: "input-group flex-nowrap" }
const _hoisted_87 = { class: "flex-grow-1" }
const _hoisted_88 = ["disabled"]
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-upload" }, null, -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "col-lg-6 fv-row mb-4" }
const _hoisted_92 = { class: "mb-2" }
const _hoisted_93 = { class: "input-group flex-nowrap" }
const _hoisted_94 = { class: "flex-grow-1" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "la la-copy" }, null, -1))
const _hoisted_96 = [
  _hoisted_95
]
const _hoisted_97 = { "data-kt-stepper-element": "content" }
const _hoisted_98 = { class: "w-100" }
const _hoisted_99 = { class: "d-flex align-items-center mb-2" }
const _hoisted_100 = { class: "required" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Specify your schedule"
}, null, -1))
const _hoisted_102 = { class: "row" }
const _hoisted_103 = { class: "col-lg-5 col-md-5 mb-6" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-1 d-none d-lg-block text-end pt-4" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right fs-2" })
], -1))
const _hoisted_105 = { class: "col-lg-5 col-md-5 mb-6" }
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-md-12" }
const _hoisted_108 = { class: "form-check form-check-inline" }
const _hoisted_109 = ["disabled"]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "repeat"
}, " Repeat ", -1))
const _hoisted_111 = { class: "pt-0" }
const _hoisted_112 = { id: "kt_create_new_payment_method" }
const _hoisted_113 = { class: "py-1" }
const _hoisted_114 = { class: "py-3 d-flex flex-stack flex-wrap rounded border-primary border border-dashed p-4" }
const _hoisted_115 = { class: "d-flex align-items-center" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-50px me-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-light-success" }, " W ")
], -1))
const _hoisted_117 = { class: "d-flex flex-column" }
const _hoisted_118 = { class: "text-start" }
const _hoisted_119 = { class: "fs-7 text-muted" }
const _hoisted_120 = { class: "d-flex my-3 ms-9" }
const _hoisted_121 = { class: "form-check form-check-custom form-check-solid me-5" }
const _hoisted_122 = {
  id: "weekly_management",
  class: "schedule-collapse"
}
const _hoisted_123 = { class: "d-flex flex-wrap py-5" }
const _hoisted_124 = { class: "flex-equal me-5" }
const _hoisted_125 = { class: "form-check form-check-inline m-4" }
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "checkSelectAll"
}, " Select All ", -1))
const _hoisted_127 = { class: "card-body" }
const _hoisted_128 = ["id", "value"]
const _hoisted_129 = ["for"]
const _hoisted_130 = { class: "card-body" }
const _hoisted_131 = { class: "col-md-12" }
const _hoisted_132 = { class: "" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label control-label my-3",
  for: "repeatEveryHourWeekly",
  style: {"float":"left"}
}, " Repeat every ", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3", -1))
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "4", -1))
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6", -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8", -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "11" }, "11", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "12" }, "12", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "13" }, "13", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "14" }, "14", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "15" }, "15", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "16" }, "16", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "17" }, "17", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "18" }, "18", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "19" }, "19", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "21" }, "21", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "22" }, "22", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "23" }, "23", -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "24" }, "24", -1))
const _hoisted_158 = [
  _hoisted_134,
  _hoisted_135,
  _hoisted_136,
  _hoisted_137,
  _hoisted_138,
  _hoisted_139,
  _hoisted_140,
  _hoisted_141,
  _hoisted_142,
  _hoisted_143,
  _hoisted_144,
  _hoisted_145,
  _hoisted_146,
  _hoisted_147,
  _hoisted_148,
  _hoisted_149,
  _hoisted_150,
  _hoisted_151,
  _hoisted_152,
  _hoisted_153,
  _hoisted_154,
  _hoisted_155,
  _hoisted_156,
  _hoisted_157
]
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"float":"left"},
  class: "control-label my-3"
}, " hour(s)", -1))
const _hoisted_160 = { class: "py-1" }
const _hoisted_161 = { class: "py-3 d-flex flex-stack flex-wrap rounded border-primary border border-dashed p-4" }
const _hoisted_162 = { class: "d-flex align-items-center" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-50px me-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-light-danger" }, " M ")
], -1))
const _hoisted_164 = { class: "d-flex flex-column" }
const _hoisted_165 = { class: "text-start" }
const _hoisted_166 = { class: "fs-7 text-muted" }
const _hoisted_167 = { class: "d-flex my-3 ms-9" }
const _hoisted_168 = { class: "form-check form-check-custom form-check-solid me-5" }
const _hoisted_169 = {
  id: "monthly_management",
  class: "schedule-collapse"
}
const _hoisted_170 = { class: "d-flex flex-wrap py-5" }
const _hoisted_171 = { class: "flex-equal me-5" }
const _hoisted_172 = { class: "col-lg-10" }
const _hoisted_173 = { class: "form-check form-check-inline me-8" }
const _hoisted_174 = {
  class: "form-check-label",
  for: "rad1"
}
const _hoisted_175 = { class: "form-check form-check-inline me-8" }
const _hoisted_176 = {
  class: "form-check-label",
  for: "rad2"
}
const _hoisted_177 = { class: "form-check form-check-inline me-8" }
const _hoisted_178 = {
  class: "form-check-label",
  for: "rad3"
}
const _hoisted_179 = { class: "mt-4" }
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label my-3",
  style: {"float":"left"}
}, "Every ", -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3", -1))
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "4", -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6", -1))
const _hoisted_187 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7", -1))
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8", -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9", -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "11" }, "11", -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "12" }, "12", -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "13" }, "13", -1))
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "14" }, "14", -1))
const _hoisted_195 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "15" }, "15", -1))
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "16" }, "16", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "17" }, "17", -1))
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "18" }, "18", -1))
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "19" }, "19", -1))
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "21" }, "21", -1))
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "22" }, "22", -1))
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "23" }, "23", -1))
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "24" }, "24", -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1))
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "26" }, "26", -1))
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "27" }, "27", -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "28" }, "28", -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "29" }, "29", -1))
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "30" }, "30", -1))
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "31" }, "31", -1))
const _hoisted_212 = [
  _hoisted_181,
  _hoisted_182,
  _hoisted_183,
  _hoisted_184,
  _hoisted_185,
  _hoisted_186,
  _hoisted_187,
  _hoisted_188,
  _hoisted_189,
  _hoisted_190,
  _hoisted_191,
  _hoisted_192,
  _hoisted_193,
  _hoisted_194,
  _hoisted_195,
  _hoisted_196,
  _hoisted_197,
  _hoisted_198,
  _hoisted_199,
  _hoisted_200,
  _hoisted_201,
  _hoisted_202,
  _hoisted_203,
  _hoisted_204,
  _hoisted_205,
  _hoisted_206,
  _hoisted_207,
  _hoisted_208,
  _hoisted_209,
  _hoisted_210,
  _hoisted_211
]
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"float":"left"},
  class: "control-label my-3"
}, " of the month", -1))
const _hoisted_214 = { class: "col-lg-10" }
const _hoisted_215 = { class: "" }
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label my-3",
  for: "repeatEveryHourMonthly",
  style: {"float":"left","margin-left":"100px"}
}, " Repeat every ", -1))
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1))
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_219 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3", -1))
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "4", -1))
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6", -1))
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7", -1))
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8", -1))
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9", -1))
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_227 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "11" }, "11", -1))
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "12" }, "12", -1))
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "13" }, "13", -1))
const _hoisted_230 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "14" }, "14", -1))
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "15" }, "15", -1))
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "16" }, "16", -1))
const _hoisted_233 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "17" }, "17", -1))
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "18" }, "18", -1))
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "19" }, "19", -1))
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_237 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "21" }, "21", -1))
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "22" }, "22", -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "23" }, "23", -1))
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "24" }, "24", -1))
const _hoisted_241 = [
  _hoisted_217,
  _hoisted_218,
  _hoisted_219,
  _hoisted_220,
  _hoisted_221,
  _hoisted_222,
  _hoisted_223,
  _hoisted_224,
  _hoisted_225,
  _hoisted_226,
  _hoisted_227,
  _hoisted_228,
  _hoisted_229,
  _hoisted_230,
  _hoisted_231,
  _hoisted_232,
  _hoisted_233,
  _hoisted_234,
  _hoisted_235,
  _hoisted_236,
  _hoisted_237,
  _hoisted_238,
  _hoisted_239,
  _hoisted_240
]
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"float":"left"},
  class: "control-label my-3"
}, " hour(s)", -1))
const _hoisted_243 = { class: "py-1" }
const _hoisted_244 = { class: "py-3 d-flex flex-stack flex-wrap rounded border-primary border border-dashed p-4" }
const _hoisted_245 = { class: "d-flex align-items-center" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "symbol symbol-50px me-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "symbol-label bg-light-warning" }, " Q ")
], -1))
const _hoisted_247 = { class: "d-flex flex-column" }
const _hoisted_248 = { class: "text-start" }
const _hoisted_249 = { class: "fs-7 text-muted" }
const _hoisted_250 = { class: "d-flex my-3 ms-9" }
const _hoisted_251 = { class: "form-check form-check-custom form-check-solid me-5" }
const _hoisted_252 = {
  id: "quarterly_management",
  class: "schedule-collapse"
}
const _hoisted_253 = { class: "row" }
const _hoisted_254 = {
  class: "row",
  style: {"margin-top":"20px"}
}
const _hoisted_255 = { class: "col-lg-4" }
const _hoisted_256 = {
  class: "form-check-label",
  style: {"margin-left":"10px"},
  for: "rad1"
}
const _hoisted_257 = { class: "col-lg-4" }
const _hoisted_258 = {
  class: "form-check-label",
  style: {"margin-left":"10px"},
  for: "rad2"
}
const _hoisted_259 = { class: "col-lg-4" }
const _hoisted_260 = {
  class: "form-check-label",
  style: {"margin-left":"10px"},
  for: "rad3"
}
const _hoisted_261 = {
  class: "col-lg-4",
  style: {"margin-top":"20px"}
}
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "control-label my-3",
  style: {"float":"left"}
}, "Every ", -1))
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1))
const _hoisted_264 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3", -1))
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "4", -1))
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6", -1))
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7", -1))
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8", -1))
const _hoisted_271 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9", -1))
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_273 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "11" }, "11", -1))
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "12" }, "12", -1))
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "13" }, "13", -1))
const _hoisted_276 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "14" }, "14", -1))
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "15" }, "15", -1))
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "16" }, "16", -1))
const _hoisted_279 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "17" }, "17", -1))
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "18" }, "18", -1))
const _hoisted_281 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "19" }, "19", -1))
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "21" }, "21", -1))
const _hoisted_284 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "22" }, "22", -1))
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "23" }, "23", -1))
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "24" }, "24", -1))
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1))
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "26" }, "26", -1))
const _hoisted_289 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "27" }, "27", -1))
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "28" }, "28", -1))
const _hoisted_291 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "29" }, "29", -1))
const _hoisted_292 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "30" }, "30", -1))
const _hoisted_293 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "31" }, "31", -1))
const _hoisted_294 = [
  _hoisted_263,
  _hoisted_264,
  _hoisted_265,
  _hoisted_266,
  _hoisted_267,
  _hoisted_268,
  _hoisted_269,
  _hoisted_270,
  _hoisted_271,
  _hoisted_272,
  _hoisted_273,
  _hoisted_274,
  _hoisted_275,
  _hoisted_276,
  _hoisted_277,
  _hoisted_278,
  _hoisted_279,
  _hoisted_280,
  _hoisted_281,
  _hoisted_282,
  _hoisted_283,
  _hoisted_284,
  _hoisted_285,
  _hoisted_286,
  _hoisted_287,
  _hoisted_288,
  _hoisted_289,
  _hoisted_290,
  _hoisted_291,
  _hoisted_292,
  _hoisted_293
]
const _hoisted_295 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"float":"left"},
  class: "control-label my-3"
}, " of the month", -1))
const _hoisted_296 = {
  class: "col-lg-4",
  style: {"margin-top":"20px"}
}
const _hoisted_297 = { class: "" }
const _hoisted_298 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label control-label my-3",
  for: "repeatEveryHourQuarterly",
  style: {"float":"left"}
}, " Repeat every ", -1))
const _hoisted_299 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "1", -1))
const _hoisted_300 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "2", -1))
const _hoisted_301 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "3", -1))
const _hoisted_302 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "4" }, "4", -1))
const _hoisted_303 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1))
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "6" }, "6", -1))
const _hoisted_305 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "7" }, "7", -1))
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "8" }, "8", -1))
const _hoisted_307 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "9" }, "9", -1))
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_309 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "11" }, "11", -1))
const _hoisted_310 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "12" }, "12", -1))
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "13" }, "13", -1))
const _hoisted_312 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "14" }, "14", -1))
const _hoisted_313 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "15" }, "15", -1))
const _hoisted_314 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "16" }, "16", -1))
const _hoisted_315 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "17" }, "17", -1))
const _hoisted_316 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "18" }, "18", -1))
const _hoisted_317 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "19" }, "19", -1))
const _hoisted_318 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "21" }, "21", -1))
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "22" }, "22", -1))
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "23" }, "23", -1))
const _hoisted_322 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "24" }, "24", -1))
const _hoisted_323 = [
  _hoisted_299,
  _hoisted_300,
  _hoisted_301,
  _hoisted_302,
  _hoisted_303,
  _hoisted_304,
  _hoisted_305,
  _hoisted_306,
  _hoisted_307,
  _hoisted_308,
  _hoisted_309,
  _hoisted_310,
  _hoisted_311,
  _hoisted_312,
  _hoisted_313,
  _hoisted_314,
  _hoisted_315,
  _hoisted_316,
  _hoisted_317,
  _hoisted_318,
  _hoisted_319,
  _hoisted_320,
  _hoisted_321,
  _hoisted_322
]
const _hoisted_324 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  style: {"float":"left"},
  class: "control-label my-3"
}, " hour(s)", -1))
const _hoisted_325 = { "data-kt-stepper-element": "content" }
const _hoisted_326 = { class: "w-100" }
const _hoisted_327 = { class: "d-flex align-items-center fs-5 mb-2" }
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  title: "Your provided details are"
}, null, -1))
const _hoisted_329 = { class: "row mb-12" }
const _hoisted_330 = {
  id: "kt_create_new_payment_method_1",
  class: "collapse show",
  style: {}
}
const _hoisted_331 = { class: "d-flex flex-wrap py-5" }
const _hoisted_332 = { class: "flex-equal me-5" }
const _hoisted_333 = { class: "table table-flush gy-1" }
const _hoisted_334 = { class: "" }
const _hoisted_335 = { class: "py-3 text-muted w-175px" }
const _hoisted_336 = { class: "py-3 text-gray-800" }
const _hoisted_337 = { class: "py-3 text-muted w-175px" }
const _hoisted_338 = { class: "py-3 text-gray-800" }
const _hoisted_339 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_340 = { class: "py-3 text-muted w-175px" }
const _hoisted_341 = { class: "py-3 text-gray-800" }
const _hoisted_342 = { class: "py-3 text-muted w-175px" }
const _hoisted_343 = { class: "py-3 text-gray-800" }
const _hoisted_344 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, null, -1))
const _hoisted_345 = { class: "py-3 text-muted w-175px" }
const _hoisted_346 = { class: "py-3 text-gray-800" }
const _hoisted_347 = { class: "py-3 text-muted w-175px" }
const _hoisted_348 = { class: "py-3 text-gray-800" }
const _hoisted_349 = { key: 0 }
const _hoisted_350 = { class: "py-3 text-muted w-175px" }
const _hoisted_351 = { class: "py-3 text-gray-800" }
const _hoisted_352 = ["innerHTML"]
const _hoisted_353 = { key: 1 }
const _hoisted_354 = { class: "py-3 text-muted w-175px" }
const _hoisted_355 = { class: "py-3 text-gray-800 mr-3" }
const _hoisted_356 = ["innerHTML"]
const _hoisted_357 = { key: 2 }
const _hoisted_358 = { class: "py-3 text-muted w-175px" }
const _hoisted_359 = { class: "py-3 text-gray-800" }
const _hoisted_360 = ["innerHTML"]
const _hoisted_361 = { "data-kt-stepper-element": "content" }
const _hoisted_362 = { class: "w-100 text-center" }
const _hoisted_363 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Release!", -1))
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-3" }, " Submit your event to kickstart. ", -1))
const _hoisted_365 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center px-4 py-15" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://preview.keenthemes.com/metronic8/demo1/assets/media/illustrations/sketchy-1/9.png",
    alt: "",
    class: "mw-100 mh-300px"
  })
], -1))
const _hoisted_366 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_367 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_368 = { class: "svg-icon svg-icon-3 me-1" }
const _hoisted_369 = /*#__PURE__*/_createTextVNode(" Close ")
const _hoisted_370 = { class: "indicator-label" }
const _hoisted_371 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_373 = {
  key: 3,
  type: "submit",
  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px"
}
const _hoisted_374 = { class: "svg-icon svg-icon-3 ms-1 me-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        class: "form",
        ref: "formRef",
        id: "kt_modal_create_app_form",
        onSubmit: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.handleStep && _ctx.handleStep(...args))),
        "validation-schema": _ctx.currentSchema
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.t("pages.event.addEvent")), 513), [
              [_vShow, !_ctx.editEvent]
            ]),
            _withDirectives(_createElementVNode("h2", null, _toDisplayString(_ctx.t("pages.event.editEvent")), 513), [
              [_vShow, _ctx.editEvent]
            ]),
            _createElementVNode("div", {
              class: "btn btn-sm btn-icon btn-active-color-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
            }, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "stepper-item current",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(1)), ["stop"]))
                  }, [
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.t("common.details")), 1),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t("pages.event.nameAndType")), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(2)), ["stop"]))
                  }, [
                    _hoisted_17,
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h3", _hoisted_20, _toDisplayString(_ctx.t("pages.event.communication")), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.t("pages.event.selectCommunicationMode")), 1)
                    ])
                  ]),
                  _withDirectives(_createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(3)), ["stop"]))
                  }, [
                    _hoisted_22,
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.t("common.schedule")), 1),
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.t("pages.event.selectYourSchedule")), 1)
                    ])
                  ], 512), [
                    [_vShow, _ctx.data_dummy.eventSubType == '9']
                  ]),
                  _createElementVNode("div", {
                    class: "stepper-item",
                    "data-kt-stepper-element": "nav",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.moveToSpecificStep(4)), ["stop"]))
                  }, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.data_dummy.eventSubType != "9" ? 3 : 4), 1)
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.t("common.preview")), 1),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.t("pages.event.yourProvidedDetails")), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.t("common.name")), 1),
                        _hoisted_40
                      ]),
                      _createVNode(_component_Field, {
                        type: "text",
                        class: "form-control",
                        name: "eventName",
                        placeholder: "",
                        modelValue: _ctx.data_dummy.eventName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.data_dummy.eventName) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        class: "fv-plugins-message-container invalid-feedback",
                        name: "eventName"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("label", _hoisted_43, [
                          _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.t("common.type")), 1),
                          _hoisted_45
                        ]),
                        _createVNode(_component_Field, {
                          name: "eventType",
                          modelValue: _ctx.data_dummy.eventType,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.data_dummy.eventType) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              onChange: _ctx.onTypeChange,
                              modelValue: _ctx.data_dummy.eventType,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.data_dummy.eventType) = $event)),
                              placeholder: _ctx.typePlaceholder,
                              filterable: "",
                              class: "form-input-lg"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (option, o) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: o,
                                    class: "form-input-lg",
                                    label: option.text,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["onChange", "modelValue", "placeholder"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "eventType"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("label", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.t("common.subType")), 1),
                          _hoisted_49
                        ]),
                        _createVNode(_component_Field, {
                          name: "eventSubType",
                          modelValue: _ctx.data_dummy.eventSubType,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data_dummy.eventSubType) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.data_dummy.eventSubType,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.data_dummy.eventSubType) = $event)),
                              placeholder: "Select Sub Type",
                              class: "form-input-lg",
                              onChange: _ctx.onSubTypeChange,
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subTypeItems, (option, o) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: o,
                                    class: "form-input-lg",
                                    label: option.text,
                                    value: option.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "eventSubType"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("pages.email.provider")), 1),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_Field, {
                            name: "provider",
                            modelValue: _ctx.data_dummy.provider,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.data_dummy.provider) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                placeholder: "Provider",
                                modelValue: _ctx.data_dummy.provider,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.data_dummy.provider) = $event)),
                                filterable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailProviders, (option, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: option.text,
                                      value: option.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "provider"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.t("common.status")), 1),
                        _createElementVNode("div", _hoisted_56, [
                          _createVNode(_component_Field, {
                            name: "status",
                            modelValue: _ctx.data_dummy.status,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.data_dummy.status) = $event))
                          }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(_component_el_input, _mergeProps(field, {
                                modelValue: _ctx.data_dummy.status,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.data_dummy.status) = $event)),
                                disabled: "",
                                class: "check-status"
                              }), null, 16, ["modelValue"])
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            class: "fv-plugins-message-container invalid-feedback",
                            name: "status"
                          })
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("label", _hoisted_61, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.t("pages.event.communicationMode")), 1),
                          _hoisted_62
                        ]),
                        _createVNode(_component_Field, {
                          name: "communicationMode",
                          class: "form-select form-control",
                          modelValue: _ctx.mode,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mode) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_el_input, _mergeProps(field, {
                              modelValue: _ctx.mode,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.mode) = $event)),
                              disabled: ""
                            }), null, 16, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "communicationMode"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("label", _hoisted_64, [
                          (_ctx.mode === 'EMAIL')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, "Email Template "))
                            : _createCommentVNode("", true),
                          (_ctx.mode === 'SMS')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_66, _toDisplayString(_ctx.t("common.to")), 1))
                            : _createCommentVNode("", true),
                          _hoisted_67
                        ]),
                        _createElementVNode("form", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              (_ctx.mode !== 'SMS')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["text-dark w-75px", {
                                  required: _ctx.mode !== 'SMS' ? true : false,
                                }])
                                  }, _toDisplayString(_ctx.t("common.to")) + ": ", 3))
                                : _createCommentVNode("", true),
                              (
                                  _ctx.data_dummy.eventSubType &&
                                  _ctx.data_dummy.eventSubType != '9'
                                )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                    _createVNode(_component_Field, {
                                      name: "TO_2",
                                      modelValue: _ctx.targetReceipentTO.TO,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.targetReceipentTO.TO) = $event))
                                    }, {
                                      default: _withCtx(({ field }) => [
                                        _createVNode(_component_VZMultiSelect, _mergeProps({
                                          modelValue: _ctx.targetReceipentTO.TO,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.targetReceipentTO.TO) = $event)),
                                          disabled: "",
                                          maxSelectedItems: "70",
                                          element: {
                                      options: _ctx.recipientOptions.map(
                                        ({ text: label, value }) => ({
                                          label,
                                          value,
                                        })
                                      ),
                                      multiSelect: true,
                                      placeholder: 'Please select recipient',
                                    }
                                        }, field), null, 16, ["modelValue", "element"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      class: "fv-plugins-message-container invalid-feedback",
                                      name: "TO_2"
                                    })
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                                    _createVNode(_component_Field, {
                                      name: "TO",
                                      modelValue: _ctx.targetReceipentTO.TO,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.targetReceipentTO.TO) = $event))
                                    }, {
                                      default: _withCtx(({ field }) => [
                                        _createVNode(_component_VZMultiSelect, _mergeProps({
                                          modelValue: _ctx.targetReceipentTO.TO,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.targetReceipentTO.TO) = $event)),
                                          maxSelectedItems: "70",
                                          element: {
                                      options: _ctx.recipientOptions.map(
                                        ({ text: label, value }) => ({
                                          label,
                                          value,
                                        })
                                      ),
                                      multiSelect: true,
                                      placeholder: 'Please select recipient',
                                    }
                                        }, field), null, 16, ["modelValue", "element"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      class: "fv-plugins-message-container invalid-feedback",
                                      name: "TO"
                                    })
                                  ]))
                            ]),
                            (_ctx.mode === 'EMAIL')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                  _hoisted_74,
                                  _createElementVNode("div", _hoisted_75, [
                                    _createVNode(_component_VZMultiSelect, {
                                      modelValue: _ctx.targetReceipentCC.CC,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.targetReceipentCC.CC) = $event)),
                                      maxSelectedItems: "70",
                                      element: {
                                    options: _ctx.itemsReceipents.map(
                                      ({ text: label, value }) => ({
                                        label,
                                        value,
                                      })
                                    ),
                                    multiSelect: true,
                                    placeholder: 'Please select CC recipient',
                                  }
                                    }, null, 8, ["modelValue", "element"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.mode === 'EMAIL')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                  _hoisted_77,
                                  _createElementVNode("div", _hoisted_78, [
                                    _createVNode(_component_VZMultiSelect, {
                                      modelValue: _ctx.targetReceipentBCC.BCC,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.targetReceipentBCC.BCC) = $event)),
                                      maxSelectedItems: "70",
                                      element: {
                                    options: _ctx.itemsReceipents.map(
                                      ({ text: label, value }) => ({
                                        label,
                                        value,
                                      })
                                    ),
                                    multiSelect: true,
                                    placeholder: 'Please select BCC recipient',
                                  }
                                    }, null, 8, ["modelValue", "element"])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.mode === 'EMAIL')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                  _hoisted_80,
                                  _createElementVNode("div", _hoisted_81, [
                                    _withDirectives(_createElementVNode("input", {
                                      class: "form-control border-0 min-h-45px",
                                      name: "compose_subject",
                                      placeholder: "Subject",
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.itemsBody.subject) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.itemsBody.subject]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _withDirectives(_createElementVNode("div", null, [
                              _createVNode(_component_editor, {
                                ref: "editorRef",
                                "api-key": "x9cqapxbpmngwss5qdo5ihcbbx9sihswanua4dl4tyed0nlh",
                                modelValue: _ctx.itemsBody.body,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.itemsBody.body) = $event))
                              }, null, 8, ["modelValue"])
                            ], 512), [
                              [_vShow, _ctx.mode == 'EMAIL']
                            ]),
                            (_ctx.mode === 'SMS')
                              ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                  key: 3,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.itemsBody.body) = $event)),
                                  class: "form-control min-h-200px",
                                  rows: "5",
                                  placeholder: "Enter SMS body"
                                }, null, 512)), [
                                  [_vModelText, _ctx.itemsBody.body]
                                ])
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_82
                        ]),
                        (_ctx.mode == 'EMAIL')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.t("pages.event.standardTemplate")), 1),
                                _createElementVNode("div", _hoisted_86, [
                                  _createElementVNode("div", _hoisted_87, [
                                    _createVNode(_component_Field, {
                                      name: "templateSelect",
                                      modelValue: _ctx.templateID,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.templateID) = $event))
                                    }, {
                                      default: _withCtx(({ field }) => [
                                        _createVNode(_component_Multiselect, _mergeProps({
                                          modelValue: _ctx.templateID,
                                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.templateID) = $event)),
                                          "close-on-select": false,
                                          searchable: true,
                                          "create-option": true,
                                          placeholder: "Select standard template",
                                          options: 
                                      _ctx.itemsTemplates.map(
                                        ({ text: label, value }) => ({
                                          label,
                                          value,
                                        })
                                      )
                                    
                                        }, field), null, 16, ["modelValue", "options"])
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("a", {
                                    style: {"cursor":"pointer"},
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.templateID ? _ctx.getBody() : null)),
                                    class: _normalizeClass(["input-group-text", { disabled: !_ctx.templateID }]),
                                    disabled: !_ctx.templateID
                                  }, _hoisted_90, 10, _hoisted_88)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_91, [
                                _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.t("pages.event.dynamicShortcut")), 1),
                                _createElementVNode("div", _hoisted_93, [
                                  _createElementVNode("div", _hoisted_94, [
                                    _createVNode(_component_VueMultiselect, {
                                      ref: "inputRef",
                                      modelValue: _ctx.selectedShortcut,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.selectedShortcut) = $event)),
                                      options: 
                                    _ctx.itemsDynamicShortcuts.map(
                                      ({ text: label, value }) => ({
                                        label,
                                        value,
                                      })
                                    )
                                  ,
                                      placeholder: "Select Shortcut",
                                      "track-by": "value",
                                      label: "label",
                                      "select-label": "",
                                      "deselect-label": "",
                                      "show-labels": false,
                                      "hide-selected": true,
                                      "open-direction": "bottom"
                                    }, null, 8, ["modelValue", "options"])
                                  ]),
                                  _createElementVNode("a", {
                                    style: {"cursor":"pointer"},
                                    class: "input-group-text",
                                    ref: "copyButtonRef",
                                    onClick: _cache[29] || (_cache[29] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyText && _ctx.copyText(...args)), ["prevent"]))
                                  }, _hoisted_96, 512)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", _hoisted_99, [
                      _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.t("pages.event.scheduleManagement")), 1),
                      _hoisted_101
                    ]),
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("div", _hoisted_103, [
                        _createVNode(_component_Field, {
                          name: 
                            _ctx.data_dummy.eventType == '0' ||
                            _ctx.data_dummy.eventType == '1'
                              ? 'startDate_1'
                              : 'startDate'
                          ,
                          modelValue: _ctx.startDate,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.startDate) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.startDate,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.startDate) = $event)),
                              type: "datetime",
                              timezone: "UTC",
                              "min-date": _ctx.minDate,
                              disabled: 
                              _ctx.data_dummy.eventType == '0' ||
                              _ctx.data_dummy.eventType == '1'
                            ,
                              placeholder: "Start Date",
                              format: _ctx.displayDateTime,
                              "value-format": "YYYY-MM-DD HH:mm",
                              class: "w-100",
                              teleported: false,
                              "popper-class": "custom-popper",
                              disabledDate: _ctx.disablePreviousDates
                            }, null, 8, ["modelValue", "min-date", "disabled", "format", "disabledDate"])
                          ]),
                          _: 1
                        }, 8, ["name", "modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "startDate"
                        })
                      ]),
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, [
                        _createVNode(_component_Field, {
                          name: 
                            _ctx.data_dummy.eventType == '0' ||
                            _ctx.data_dummy.eventType == '1'
                              ? 'endDate_1'
                              : 'endDate'
                          ,
                          modelValue: _ctx.endDate,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.endDate) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.endDate,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.endDate) = $event)),
                              type: "datetime",
                              "min-date": _ctx.minEndDate,
                              disabled: 
                              _ctx.data_dummy.eventType == '0' ||
                              _ctx.data_dummy.eventType == '1'
                            ,
                              placeholder: "End Date",
                              format: _ctx.displayDateTime,
                              "value-format": "YYYY-MM-DD HH:mm",
                              class: "w-100",
                              teleported: false,
                              disabledDate: _ctx.disablePreviousDates,
                              "popper-class": "custom-popper"
                            }, null, 8, ["modelValue", "min-date", "disabled", "format", "disabledDate"])
                          ]),
                          _: 1
                        }, 8, ["name", "modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          class: "fv-plugins-message-container invalid-feedback",
                          name: "endDate"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _createElementVNode("div", _hoisted_107, [
                        _createElementVNode("div", _hoisted_108, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-check-input",
                            disabled: 
                              _ctx.data_dummy.eventType == '0' ||
                              _ctx.data_dummy.eventType == '1'
                            ,
                            id: "repeat",
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.repeat) = $event)),
                            onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.formatFinalExpressions && _ctx.formatFinalExpressions(...args)))
                          }, null, 40, _hoisted_109), [
                            [_vModelCheckbox, _ctx.repeat]
                          ]),
                          _hoisted_110
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_111, [
                      _withDirectives(_createElementVNode("div", _hoisted_112, [
                        _createElementVNode("div", _hoisted_113, [
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, [
                              _hoisted_116,
                              _createElementVNode("span", _hoisted_117, [
                                _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.t("pages.event.weekly")), 1),
                                _createElementVNode("span", _hoisted_119, _toDisplayString(_ctx.t("pages.event.chooseAnyDayOfTheWeek")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_120, [
                              _createElementVNode("label", _hoisted_121, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  value: "Weekly",
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.scheduleType) = $event)),
                                  onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.handleScheduleTypeChange('Weekly')))
                                }, null, 544), [
                                  [_vModelRadio, _ctx.scheduleType]
                                ])
                              ])
                            ])
                          ]),
                          _createVNode(_Transition, {
                            onBeforeEnter: _ctx.beforeEnter,
                            onEnter: _ctx.enter,
                            onAfterEnter: _ctx.afterEnter,
                            onBeforeLeave: _ctx.beforeLeave,
                            onLeave: _ctx.leave,
                            onAfterLeave: _ctx.afterLeave
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", _hoisted_122, [
                                _createElementVNode("div", _hoisted_123, [
                                  _createElementVNode("div", _hoisted_124, [
                                    _createElementVNode("div", _hoisted_125, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        class: "form-check-input",
                                        id: "checkSelectAll",
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.selectAll) = $event)),
                                        onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                                      }, null, 544), [
                                        [_vModelCheckbox, _ctx.selectAll]
                                      ]),
                                      _hoisted_126
                                    ]),
                                    _createElementVNode("div", _hoisted_127, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allDaysOfWeek, (day) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: day,
                                          class: "form-check form-check-inline"
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            class: "form-check-input",
                                            id: `check${day}`,
                                            value: day,
                                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.checkedDaysOfWeek) = $event)),
                                            onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.changeWeekly && _ctx.changeWeekly(...args)))
                                          }, null, 40, _hoisted_128), [
                                            [_vModelCheckbox, _ctx.checkedDaysOfWeek]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: `check${day}`
                                          }, _toDisplayString(day), 9, _hoisted_129)
                                        ]))
                                      }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_130, [
                                      _createElementVNode("div", _hoisted_131, [
                                        _createElementVNode("div", _hoisted_132, [
                                          _hoisted_133,
                                          _withDirectives(_createElementVNode("select", {
                                            class: "form-control form-select",
                                            style: {"float":"left","width":"80px","height":"40px","margin-left":"5px","margin-right":"5px"},
                                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.repeatEveryHourWeekly) = $event)),
                                            onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.addEveryHour()))
                                          }, _hoisted_158, 544), [
                                            [_vModelSelect, _ctx.repeatEveryHourWeekly]
                                          ]),
                                          _hoisted_159
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ], 512), [
                                [_vShow, _ctx.scheduleType === 'Weekly']
                              ])
                            ]),
                            _: 1
                          }, 8, ["onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])
                        ]),
                        _createElementVNode("div", _hoisted_160, [
                          _createElementVNode("div", _hoisted_161, [
                            _createElementVNode("div", _hoisted_162, [
                              _hoisted_163,
                              _createElementVNode("span", _hoisted_164, [
                                _createElementVNode("span", _hoisted_165, _toDisplayString(_ctx.t("pages.event.monthly")), 1),
                                _createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.t("pages.event.chooseAnyDayOfTheMonth")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_167, [
                              _createElementVNode("label", _hoisted_168, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  value: "Monthly",
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.scheduleType) = $event)),
                                  onChange: _cache[45] || (_cache[45] = ($event: any) => (_ctx.handleScheduleTypeChange('Monthly')))
                                }, null, 544), [
                                  [_vModelRadio, _ctx.scheduleType]
                                ])
                              ])
                            ])
                          ]),
                          _createVNode(_Transition, {
                            onBeforeEnter: _ctx.beforeEnter,
                            onEnter: _ctx.enter,
                            onAfterEnter: _ctx.afterEnter,
                            onBeforeLeave: _ctx.beforeLeave,
                            onLeave: _ctx.leave,
                            onAfterLeave: _ctx.afterLeave
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", _hoisted_169, [
                                _createElementVNode("div", _hoisted_170, [
                                  _createElementVNode("div", _hoisted_171, [
                                    _createElementVNode("div", _hoisted_172, [
                                      _createElementVNode("div", _hoisted_173, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "radio",
                                          class: "form-check-input",
                                          id: "rad_first_monthly",
                                          name: "radMontlhy",
                                          value: "1",
                                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.dayOfMonth) = $event)),
                                          onChange: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.changeMonthly && _ctx.changeMonthly(...args)))
                                        }, null, 544), [
                                          [_vModelRadio, _ctx.dayOfMonth]
                                        ]),
                                        _createElementVNode("label", _hoisted_174, _toDisplayString(_ctx.t("pages.event.firstDayOfMonth")), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_175, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "radio",
                                          class: "form-check-input",
                                          id: "rad_middle_monthly",
                                          name: "radMontlhy",
                                          value: "15",
                                          "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.dayOfMonth) = $event)),
                                          onChange: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.changeMonthly && _ctx.changeMonthly(...args)))
                                        }, null, 544), [
                                          [_vModelRadio, _ctx.dayOfMonth]
                                        ]),
                                        _createElementVNode("label", _hoisted_176, _toDisplayString(_ctx.t("pages.event.middleOfMonth")), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_177, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "radio",
                                          class: "form-check-input",
                                          id: "rad_last_monthly",
                                          name: "radMontlhy",
                                          value: "L",
                                          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.dayOfMonth) = $event)),
                                          onChange: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.changeMonthly && _ctx.changeMonthly(...args)))
                                        }, null, 544), [
                                          [_vModelRadio, _ctx.dayOfMonth]
                                        ]),
                                        _createElementVNode("label", _hoisted_178, _toDisplayString(_ctx.t("pages.event.lastDayOfMonth")), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_179, [
                                        _hoisted_180,
                                        _withDirectives(_createElementVNode("select", {
                                          class: "form-control form-select",
                                          style: {"float":"left","width":"80px","height":"40px","margin-left":"5px","margin-right":"5px"},
                                          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.dayOfMonth) = $event)),
                                          onChange: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.changeMonthly && _ctx.changeMonthly(...args)))
                                        }, _hoisted_212, 544), [
                                          [_vModelSelect, _ctx.dayOfMonth]
                                        ]),
                                        _hoisted_213
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_214, [
                                      _createElementVNode("div", _hoisted_215, [
                                        _hoisted_216,
                                        _withDirectives(_createElementVNode("select", {
                                          class: "form-control form-select",
                                          style: {"float":"left","width":"80px","height":"40px","margin-left":"5px","margin-right":"5px"},
                                          "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.repeatEveryHourMonthly) = $event)),
                                          onChange: _cache[55] || (_cache[55] = ($event: any) => (_ctx.addEveryHour()))
                                        }, _hoisted_241, 544), [
                                          [_vModelSelect, _ctx.repeatEveryHourMonthly]
                                        ]),
                                        _hoisted_242
                                      ])
                                    ])
                                  ])
                                ])
                              ], 512), [
                                [_vShow, _ctx.scheduleType === 'Monthly']
                              ])
                            ]),
                            _: 1
                          }, 8, ["onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])
                        ]),
                        _createElementVNode("div", _hoisted_243, [
                          _createElementVNode("div", _hoisted_244, [
                            _createElementVNode("div", _hoisted_245, [
                              _hoisted_246,
                              _createElementVNode("span", _hoisted_247, [
                                _createElementVNode("span", _hoisted_248, _toDisplayString(_ctx.t("pages.event.quarterly")), 1),
                                _createElementVNode("span", _hoisted_249, _toDisplayString(_ctx.t("pages.event.ChooseAnyDayOftheQuarter")), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_250, [
                              _createElementVNode("label", _hoisted_251, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "radio",
                                  value: "Quarterly",
                                  "data-bs-toggle": "collapse",
                                  "data-bs-target": "#quarterly_management",
                                  "aria-expanded": "false",
                                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.scheduleType) = $event)),
                                  onChange: _cache[57] || (_cache[57] = ($event: any) => (
                                    _ctx.handleScheduleTypeChange('Quarterly')
                                  ))
                                }, null, 544), [
                                  [_vModelRadio, _ctx.scheduleType]
                                ])
                              ])
                            ])
                          ]),
                          _createVNode(_Transition, {
                            onBeforeEnter: _ctx.beforeEnter,
                            onEnter: _ctx.enter,
                            onAfterEnter: _ctx.afterEnter,
                            onBeforeLeave: _ctx.beforeLeave,
                            onLeave: _ctx.leave,
                            onAfterLeave: _ctx.afterLeave
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", _hoisted_252, [
                                _createElementVNode("div", _hoisted_253, [
                                  _createElementVNode("div", _hoisted_254, [
                                    _createElementVNode("div", _hoisted_255, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        class: "form-check-input",
                                        id: "rad_first_quarterly",
                                        name: "radQuarterly",
                                        value: "1",
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.dayOfQuarter) = $event)),
                                        onChange: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.changeQuarterly && _ctx.changeQuarterly(...args)))
                                      }, null, 544), [
                                        [_vModelRadio, _ctx.dayOfQuarter]
                                      ]),
                                      _createElementVNode("label", _hoisted_256, _toDisplayString(_ctx.t("pages.event.firstDayOfQuarter")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_257, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        class: "form-check-input",
                                        id: "rad_middle_quarterly",
                                        name: "radQuarterly",
                                        value: "15",
                                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.dayOfQuarter) = $event)),
                                        onChange: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.changeQuarterly && _ctx.changeQuarterly(...args)))
                                      }, null, 544), [
                                        [_vModelRadio, _ctx.dayOfQuarter]
                                      ]),
                                      _createElementVNode("label", _hoisted_258, _toDisplayString(_ctx.t("pages.event.middleOfQuarter")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_259, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        class: "form-check-input",
                                        id: "rad_last_quarterly",
                                        name: "radQuarterly",
                                        value: "L",
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.dayOfQuarter) = $event)),
                                        onChange: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_ctx.changeQuarterly && _ctx.changeQuarterly(...args)))
                                      }, null, 544), [
                                        [_vModelRadio, _ctx.dayOfQuarter]
                                      ]),
                                      _createElementVNode("label", _hoisted_260, _toDisplayString(_ctx.t("pages.event.lastDayOfQuarter")), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_261, [
                                    _hoisted_262,
                                    _withDirectives(_createElementVNode("select", {
                                      class: "form-control form-select",
                                      style: {"float":"left","width":"80px","height":"40px","margin-left":"5px","margin-right":"5px"},
                                      "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.dayOfQuarter) = $event)),
                                      onChange: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.changeMonthly && _ctx.changeMonthly(...args)))
                                    }, _hoisted_294, 544), [
                                      [_vModelSelect, _ctx.dayOfQuarter]
                                    ]),
                                    _hoisted_295
                                  ]),
                                  _createElementVNode("div", _hoisted_296, [
                                    _createElementVNode("div", _hoisted_297, [
                                      _hoisted_298,
                                      _withDirectives(_createElementVNode("select", {
                                        class: "form-control form-select",
                                        style: {"float":"left","width":"80px","height":"40px","margin-left":"5px","margin-right":"5px"},
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.repeatEveryHourQuarterly) = $event)),
                                        onChange: _cache[67] || (_cache[67] = ($event: any) => (_ctx.addEveryHour()))
                                      }, _hoisted_323, 544), [
                                        [_vModelSelect, _ctx.repeatEveryHourQuarterly]
                                      ]),
                                      _hoisted_324
                                    ])
                                  ])
                                ])
                              ], 512), [
                                [_vShow, _ctx.scheduleType === 'Quarterly']
                              ])
                            ]),
                            _: 1
                          }, 8, ["onBeforeEnter", "onEnter", "onAfterEnter", "onBeforeLeave", "onLeave", "onAfterLeave"])
                        ])
                      ], 512), [
                        [_vShow, _ctx.repeat]
                      ])
                    ])
                  ])
                ], 512), [
                  [_vShow, _ctx.data_dummy.eventSubType == '9']
                ]),
                _createElementVNode("div", _hoisted_325, [
                  _createElementVNode("div", _hoisted_326, [
                    _createElementVNode("label", _hoisted_327, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("pages.event.providedDetailsAre")), 1),
                      _hoisted_328
                    ]),
                    _createElementVNode("div", _hoisted_329, [
                      _createElementVNode("div", _hoisted_330, [
                        _createElementVNode("div", _hoisted_331, [
                          _createElementVNode("div", _hoisted_332, [
                            _createElementVNode("table", _hoisted_333, [
                              _createElementVNode("tbody", null, [
                                _createElementVNode("tr", _hoisted_334, [
                                  _createElementVNode("td", _hoisted_335, _toDisplayString(_ctx.t("common.name")), 1),
                                  _createElementVNode("td", _hoisted_336, _toDisplayString(_ctx.data_dummy.eventName), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_337, _toDisplayString(_ctx.t("pages.event.eventType")), 1),
                                  _createElementVNode("td", _hoisted_338, _toDisplayString(_ctx.items.find(
                                        (item) =>
                                          item.value == _ctx.data_dummy.eventType
                                      )?.text), 1)
                                ]),
                                _hoisted_339,
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_340, _toDisplayString(_ctx.t("common.subType")), 1),
                                  _createElementVNode("td", _hoisted_341, _toDisplayString(_ctx.subTypeItems.find(
                                        (item) =>
                                          item.value == _ctx.data_dummy.eventSubType
                                      )?.text), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_342, _toDisplayString(_ctx.t("pages.email.provider")), 1),
                                  _createElementVNode("td", _hoisted_343, _toDisplayString(_ctx.emailProviders?.find(
                                        (item) =>
                                          item.value == _ctx.data_dummy.provider
                                      )?.text), 1)
                                ]),
                                _hoisted_344,
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_345, _toDisplayString(_ctx.t("common.status")), 1),
                                  _createElementVNode("td", _hoisted_346, _toDisplayString(_ctx.statusOptions.find(
                                        (item) =>
                                          item.value == _ctx.data_dummy.status
                                      )?.label ?? ""), 1)
                                ]),
                                _createElementVNode("tr", null, [
                                  _createElementVNode("td", _hoisted_347, _toDisplayString(_ctx.t("pages.event.communicationMode")), 1),
                                  _createElementVNode("td", _hoisted_348, _toDisplayString(_ctx.mode), 1)
                                ]),
                                (
                                    _ctx.mode === 'EMAIL' &&
                                    _ctx.itemsBody.subject.length > 0
                                  )
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_349, [
                                      _createElementVNode("td", _hoisted_350, _toDisplayString(_ctx.t("pages.email.subject")), 1),
                                      _createElementVNode("td", _hoisted_351, [
                                        _createElementVNode("span", {
                                          innerHTML: _ctx.itemsBody.subject
                                        }, null, 8, _hoisted_352)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                                    _ctx.mode === 'EMAIL' &&
                                    _ctx.itemsBody.body.length > 0
                                  )
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_353, [
                                      _createElementVNode("td", _hoisted_354, _toDisplayString(_ctx.t("pages.event.emailContent")), 1),
                                      _createElementVNode("td", _hoisted_355, [
                                        _createElementVNode("span", {
                                          innerHTML: _ctx.itemsBody.body
                                        }, null, 8, _hoisted_356)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.mode === 'SMS')
                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_357, [
                                      _createElementVNode("td", _hoisted_358, _toDisplayString(_ctx.t("pages.event.smsContent")), 1),
                                      _createElementVNode("td", _hoisted_359, [
                                        _createElementVNode("span", {
                                          innerHTML: _ctx.itemsBody.body
                                        }, null, 8, _hoisted_360)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_361, [
                  _createElementVNode("div", _hoisted_362, [
                    _hoisted_363,
                    _hoisted_364,
                    _hoisted_365,
                    _createTextVNode(" " + _toDisplayString(_ctx.data_dummy.data_event_name), 1)
                  ])
                ])
              ])
            ], 512)
          ]),
          _createElementVNode("div", _hoisted_366, [
            (_ctx.currentStepIndex > 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  "data-kt-stepper-action": "previous",
                  onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.previousStep()))
                }, [
                  _createElementVNode("span", _hoisted_367, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("common.back")), 1)
                ]))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[69] || (_cache[69] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["stop"]))
                }, [
                  _createElementVNode("span", _hoisted_368, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _hoisted_369
                ])),
            (_ctx.currentStepIndex === _ctx.totalSteps)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "submit",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  ref: "submitButton",
                  onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.formSubmit && _ctx.formSubmit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_370, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.save")) + " ", 1),
                    _createElementVNode("span", _hoisted_371, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ]),
                  _hoisted_372
                ], 512))
              : (_openBlock(), _createElementBlock("button", _hoisted_373, [
                  _createTextVNode(_toDisplayString(_ctx.t("common.continue")) + " ", 1),
                  _createElementVNode("span", _hoisted_374, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]))
          ])
        ])
      ], 40, _hoisted_3)
    ])
  ], 512))
}